import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { api } from '~/lib/api-client';
import { useConfirm } from '~/components/confirm-dialog';

/**
 * Sign out on this device, after a confirm: `POST /api/auth/logout`, then the
 * sign-in page. One definition for every door — User Settings → General and
 * the sidebar's user menu (FRONT-3223) — so the two can never differ.
 */
export function useSignOut() {
  const confirm = useConfirm();
  const logout = useMutation({
    mutationFn: () => api.post('/api/auth/logout'),
    onSuccess: () => {
      window.location.href = '/login';
    },
    onError: (err) => toast.error(`Sign out failed: ${(err as Error).message}`),
  });
  const signOut = async () => {
    const ok = await confirm({
      title: 'Sign out?',
      description: 'You will need to sign in again on this device.',
      confirmText: 'Sign out',
    });
    if (ok) logout.mutate();
  };
  return { signOut, isPending: logout.isPending };
}
